module.exports = __webpack_public_path__ + "img/scorecard-5.23dc3315.jpg";